import type { SVGProps } from 'react';

export default function Car2(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.75 8.75L5.85557 9.19721C5.178 9.536 4.75 10.2285 4.75 10.9861V12.25C4.75 12.8023 5.19771 13.25 5.75 13.25H6M6.75 8.75L7.52208 6.43377C7.65819 6.02543 8.04033 5.75 8.47076 5.75H12M6.75 8.75C6.75 9.57843 7.42157 10.25 8.25 10.25H12V5.75M15 13.25H9M18 13.25H18.25C18.8023 13.25 19.25 12.8023 19.25 12.25V10.9861C19.25 10.2285 18.822 9.536 18.1444 9.19721L17.25 8.75L16.4779 6.43377C16.3418 6.02543 15.9597 5.75 15.5292 5.75H12M4.75 19.25H19.25M9.25 14.5C9.25 13.5335 8.4665 12.75 7.5 12.75C6.5335 12.75 5.75 13.5335 5.75 14.5C5.75 15.4665 6.5335 16.25 7.5 16.25C8.4665 16.25 9.25 15.4665 9.25 14.5ZM18.25 14.5C18.25 13.5335 17.4665 12.75 16.5 12.75C15.5335 12.75 14.75 13.5335 14.75 14.5C14.75 15.4665 15.5335 16.25 16.5 16.25C17.4665 16.25 18.25 15.4665 18.25 14.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
